/**
 * Usage
  <app-collapsible title="Examples from other agreements">
    <ng-container class="content">
      <div>
        <strong>Example 1</strong>
        <p>
          ”I'll support John with getting ready to go to a physio appointment on Wednesdays and Fridays."
        </p>
      </div>
    </ng-container>
  </app-collapsible>

  * If we don't want the horizontal line
  <app-collapsible title="Examples from other agreements" class="no-line">
    <ng-container class="content">
      <div>
        <strong>Example 1</strong>
        <p>
          ”I'll support John with getting ready to go to a physio appointment on Wednesdays and Fridays."
        </p>
      </div>
    </ng-container>
  </app-collapsible>

  * If we want collapsed version of component than add class "rounded"
   <app-collapsible title="Examples from other agreements" class="rounded">
    <ng-container class="content">
      <div>
        <strong>Example 1</strong>
        <p>
          ”I'll support John with getting ready to go to a physio appointment on Wednesdays and Fridays."
        </p>
      </div>
    </ng-container>
  </app-collapsible>
*/

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HeadingComponent } from 'src/app/shared/components/heading/heading.component';
import { HeadingColor, HeadingStyle, HeadingType } from 'src/app/shared/components/heading/heading.types';

@Component({
  standalone: true,
  imports: [CommonModule, IonicModule, HeadingComponent],
  selector: 'app-collapsible',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss'],
})
export class CollapsibleComponent {
  // The title of the collapsible
  @Input() title: string;

  // used to change state to open or close
  @Input() isPanelExpanded = true;

  // Used to add icon to the heading
  @Input() icon: string;

  // Used to specify icon colour
  @Input() iconColor: string;

  // Categories headings and adjust icon size
  @Input() headingType: HeadingType = 'h5';

  // heading style to show heading.
  @Input() headingStyle: HeadingStyle;

  // Used to apply color to the component
  @Input() color = '';

  // Removes the padding around the component
  @Input() noPadding = false;

  // Color of heading title
  @Input() headingColor: HeadingColor;

  // expand eventEmitter
  @Output() expand = new EventEmitter<null>();

  // collapse eventEmitter
  @Output() collapse = new EventEmitter<null>();

  /**
   * On expand button click update the isPanelExpanded flag and emit event if required.
   */
  onExpandClick() {
    this.isPanelExpanded = !this.isPanelExpanded;

    // emit the collapse or expand event
    if (this.isPanelExpanded && this.expand) {
      this.expand.emit(null);
    } else if (this.collapse) {
      this.collapse.emit(null);
    }
  }
}
